export enum MeetingPanelTabs {
  chat,
  participantsControls
}